import classes from './AdvertisingDisclosure.module.css'

function AdvertisingDisclosure({ handleOpen }) {
    return(
        <div className={classes.container}>
            <p
                onClick={handleOpen}
                className={"advertising_modal"}
            >
                Advertising Disclosure
            </p>
        </div>
    )
}

export default AdvertisingDisclosure